import { routes } from "@/routes";
import { cloneElement, useEffect, useState } from "react";
import { FiChevronUp } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { signOutRequest } from "../../../store/auth/authSlice";
import Logo from "../Logo";
import classes from "./SideBar.module.css";

const SideBar = ({ isCollapsed, setIsCollapsed, isMobile }) => {
  const [popper, setPopper] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const HandleSubmitSignOut = () => {
    dispatch(signOutRequest());
    navigate("/login");
  };
  const sidebarRoutes = routes.filter((route) => route.showInSidebar);

  return (
    <div className={classes?.mainContainer}>
      <div className={classes?.logoContainer} onClick={() => navigate("/")}>
        <Logo variant={isCollapsed ? "icon" : "logo"} />
      </div>
      <div
        className={[
          classes.itemsContainer,
          isCollapsed && classes.isCollapsedContainer,
          isMobile && classes.isMobile,
        ].join(" ")}
      >
        {isCollapsed && popper && (
          <span
            className={classes.popper}
            style={{ top: `${popper.pos + 16}px` }}
          >
            {popper.value}
          </span>
        )}
        <div
          className={[
            classes.items,
            isCollapsed && classes.itemsCollapsed,
          ].join(" ")}
        >
          {sidebarRoutes
            .filter((e) => e.showInSidebar)
            .map((item, index) => {
              return (
                <RenderItem
                  icon={item?.icon}
                  title={item?.title}
                  path={item?.path}
                  subMenu={
                    item?.subMenu && item.subMenu.filter((e) => e.showInSidebar)
                  }
                  isCollapsed={isCollapsed}
                  key={index}
                  setPopper={setPopper}
                />
              );
            })}
        </div>
        {/* <div
          className={cn(
            classes.logout_btn,
            isCollapsed && classes.isCollapsedLogoutBtn
          )}
        >
          {isCollapsed ? (
            <Button>
              <IoLogOutOutline size={20} />
            </Button>
          ) : (
            <Button
              label={"Sign Out"}
              onClick={HandleSubmitSignOut}
              leftIcon={<IoLogOutOutline size={20} />}
            />
          )}
        </div> */}
      </div>
    </div>
  );
};

export default SideBar;

const RenderItem = ({
  icon,
  title,
  subMenu = [],
  path,
  isCollapsed,
  setPopper,
}) => {
  const pathname = useLocation()?.pathname;
  const active = pathname === path ? true : false;
  const [subnav, setSubnav] = useState(false);
  const subActive = subMenu.find((item, index) => item?.path == pathname);
  const showSubnav = () => setSubnav(!subnav);
  useEffect(() => {
    const allPaths = subMenu.map((item) => item?.path);
    if (allPaths.includes(pathname)) {
      setSubnav(true);
    }
  }, []);

  return (
    <>
      <Link
        className={[
          classes?.listItemContainer,
          (active || subnav) && classes?.active,
          subActive && classes?.subActive,
          subnav &&
            [isCollapsed ? classes?.isCollapsedSubnav : classes.subnav].join(
              " "
            ),
          isCollapsed ? classes.isCollapsed : "",
        ].join(" ")}
        onMouseEnter={(e) => {
          setPopper({
            pos: e.target.offsetTop - e.target.parentElement.scrollTop,
            value: title,
          });
        }}
        onMouseLeave={(e) => {
          setPopper(null);
        }}
        data-title={title}
        to={subMenu?.length > 0 ? "#" : path}
        onClick={() => {
          if (subMenu?.length > 0) {
            showSubnav(!subnav);
          }
        }}
      >
        {icon &&
          cloneElement(icon, {
            size: 20,
            color: "var(--text-color)",
            className: classes.icon,
          })}
        {!isCollapsed && <span>{title}</span>}
        {subMenu?.length > 0 && !isCollapsed && (
          <FiChevronUp size={20} className={classes?.dropDownIcon} />
        )}
      </Link>

      {subnav && (
        <div
          className={[
            classes?.subMenu,
            isCollapsed ? classes.submenuIsCollapsed : "",
          ].join(" ")}
        >
          {subMenu.map((item, index) => {
            return (
              <Link
                href={item?.path}
                className={[
                  classes?.innerItemContainer,
                  isCollapsed
                    ? classes.isCollapsed
                    : classes?.notCollapsedInnercontainer,
                  subActive?.path === item?.path && classes?.innerItemSubActive,
                ].join(" ")}
                onMouseEnter={(e) => {
                  setPopper({
                    pos:
                      e.target.offsetTop +
                      e.target.parentElement.offsetTop -
                      e.target.parentElement.parentElement.scrollTop -
                      10,
                    value: item?.title,
                  });
                }}
                onMouseLeave={(e) => {
                  setPopper(null);
                }}
                data-title={item?.title}
                key={index}
                to={item?.path}
              >
                {item?.icon &&
                  isCollapsed &&
                  cloneElement(item?.icon, {
                    size: 20,
                    color: "var(--text-color)",
                    className: classes.innerIcon,
                  })}
                {!isCollapsed && <span>{item?.title}</span>}
              </Link>
            );
          })}
        </div>
      )}
    </>
  );
};
